import { useEffect, useRef } from 'react';
import { ErrorMessageStyles } from './ErrorMessageStyles';

type Props = {
  name: string;
  errors: Record<string, any>;
  styles?: Record<string, string>;
  scrollIntoError?: boolean;
};

// TODO: should be used in all components (remove other custom <ErrorMessage />)
export const ErrorMessage = ({
  name,
  errors,
  styles = {},
  scrollIntoError = true,
}: Props) => {
  const ref = useRef<any>(null);
  const errorMessage = errors[name] ? errors[name]?.message : null;
  const isFirstError = Object.keys(errors)[0] === name;

  useEffect(() => {
    if (scrollIntoError && ref.current && errorMessage && isFirstError) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [errors, isFirstError]);

  return errorMessage ? (
    <>
      <ErrorMessageStyles bottom={styles.bottom}>
        {errorMessage}
      </ErrorMessageStyles>
      {/* serves as a focus element */}
      <span ref={ref}></span>
    </>
  ) : null;
};
